import { render, staticRenderFns } from "./LeaveTeam.vue?vue&type=template&id=67c0819c&scoped=true&"
import script from "./LeaveTeam.vue?vue&type=script&lang=js&"
export * from "./LeaveTeam.vue?vue&type=script&lang=js&"
import style0 from "./LeaveTeam.vue?vue&type=style&index=0&id=67c0819c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c0819c",
  null
  
)

export default component.exports